module.exports = __webpack_public_path__ + "static/media/sampleExcludeSuppressionListEmail.b19f134d.csv";